module.exports = __webpack_public_path__ + "img/dsg-transparent-logo.b33d204d.png";